import { ListItem, ListItemButton, ListItemText } from "@mui/material";
import dayjs from "dayjs";
import EventNoteButton from "models/actions/EventNoteButton";

const EventListItemShort = ({ object: event, primaryClick }) => {
  return (
    <ListItem
      secondaryAction={
        <EventNoteButton event={event} sx={{ marginRight: "-10px" }} />
      }
    >
      <ListItemButton onClick={() => primaryClick(event)}>
        <ListItemText
          primary={event.title}
          secondary={`with
              ${event?.action_links.map((action_link) => {
                return ` ${action_link.email_address}`;
              })}`}
        />
        <ListItemText
          secondary={dayjs(event.date).format("HH:mm")}
          sx={{ flexShrink: 0, flexGrow: 0, ml: 1 }}
        />
      </ListItemButton>
    </ListItem>
  );
};

export default EventListItemShort;
